import React from "react";
// React Table
import { Table } from "react-bootstrap";
// Styled Components
import styled from "styled-components";

const CustomTable = styled(Table)`
  position: relative;
  border-collapse: collapse;
  table-layout: initial;

  & th {
    position: sticky;
    top: 0px;
    background-color: #2a599f;
    color: white;
  }
`;

const GenericTable = ({ children, ...props }) => {
  return (
    <div className={"position-relative overflow-auto"}>
      <CustomTable striped hover {...props}>
        {children}
      </CustomTable>
    </div>
  );
};

export default GenericTable;
